import React, { useState, useEffect } from "react";
import ContentLoader from "react-content-loader";
import Tooltip from '@tippyjs/react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import { getTrans as t } from "../../../../Localization/translations";
import ACHaccountsServices from "../../../../services/ACHaccounts/ACHaccountsServices";
import AchIndex from ".";
import Helper from "../../../../Helper";

function ViewAchAccount({id,setHideShowView,hideShowAchView,hideShowachId,setHideShowAchIndex,setHideShowAchEdit,hideShowachindex,hideShowachedit,setHideShowAchID,achid}) {
    const [account, setAccount] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const { state } = useLocation();
    const navigate = useNavigate();

    const handleshowHide = () =>{
		setHideShowView(false)

  }

    useEffect(() => {
        if (!achid) {
            setLoading(false);
            setError("No ACH Account ID provided.");
            return;
        }
        ACHaccountsServices.getAchAccount(achid)
            .then(response => {
                const data = response.data && response.data.details
                    ? response.data.details
                    : null;
                if (data) {
                    setAccount(data);
                    setLoading(false);
                } else {
                    setError("No details returned from server.");
                    setLoading(false);
                }
            })
            .catch((e) => {
                setError("Failed to fetch ACH Account details.");
                setLoading(false);
            });
    }, [state]);

    const renderYN = (val) => (val === "Y" ? t("Yes") : t("No"));
    const renderStatus = (val) => (val === "Y" ? t("Active") : t("Inactive"));

    return (
        hideShowAchView === true?
        <div className="container-fluid">
            <ToastContainer />
            {loading ? (
                <ContentLoader
                    viewBox="0 0 400 160"
                    backgroundColor="rgba(0,0,0,0.06)"
                    foregroundColor="rgba(0,0,0,0.12)"
                >
                    <rect x="0" y="13" rx="4" ry="4" width="400" height="9" />
                    <rect x="0" y="29" rx="4" ry="4" width="100" height="8" />
                    <rect x="0" y="50" rx="4" ry="4" width="400" height="10" />
                    <rect x="0" y="65" rx="4" ry="4" width="400" height="10" />
                    <rect x="0" y="79" rx="4" ry="4" width="100" height="10" />
                </ContentLoader>
            ) : error ? (
                <div className="alert alert-danger mt-4">{error}</div>
            ) : (
                <>
                    <div className="header pb-0 ">
                        <div className="d-lg-flex pt-2">
                            <div>
                                <h5>{t('ACH Account Details')}</h5>
                                <h6>
                                    <span onClick={()=>handleshowHide()} className="tc text-bold cursor-pointer">{t("ACH Accounts")}</span> / <span>{t("View ACH Account")}</span>
                                </h6>
                            </div>
                        </div>
                    </div>
                    <div className="card ">
                        <div className="card-body">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-xl-3">
                                        <label className="col-lg-12 col-form-label">
                                            {t('Account Name')}
                                            <Tooltip content={t("ACH Account Name Tooltip")}></Tooltip>
                                        </label>
                                    </div>
                                    <div className="col-xl-3">
                                        <span className="col-lg-8 view-label p">
                                            {account.account_name || "None"}
                                        </span>
                                    </div>
                                    <div className="col-xl-3">
                                        <label className="col-lg-12 col-form-label">
                                            {t('ABA Routing Number')}
                                            <Tooltip content={t("ABA Routing Number Tooltip")}></Tooltip>
                                        </label>
                                    </div>
                                    <div className="col-xl-3">
                                        <span className="col-lg-8 view-label p">
                                            {account.aba_transit_number || "None"}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-3">
                                        <label className="col-lg-12 col-form-label">
                                            {t('Account Number')}
                                            <Tooltip content={t("Account Number Tooltip")}></Tooltip>
                                        </label>
                                    </div>
                                    <div className="col-xl-3">
                                        <span className="col-lg-8 view-label p">
                                            {account.account_number || "None"}
                                        </span>
                                    </div>
                                    <div className="col-xl-3">
                                        <label className="col-lg-12 col-form-label">
                                            {t('Authorization Expiration Date')}
                                            <Tooltip content={t("Authorization Expiration Date Tooltip")}></Tooltip>
                                        </label>
                                    </div>
                                    <div className="col-xl-3">
                                        <span className="col-lg-8 view-label p">
                                            {account.end_date?Helper.DateNormal(account.end_date) : ""}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-3">
                                        <label className="col-lg-12 col-form-label">
                                            {t('Authorization Received')}
                                            <Tooltip content={t("Authorization Received Tooltip")}></Tooltip>
                                        </label>
                                    </div>
                                    <div className="col-xl-3">
                                        <span className="col-lg-8 view-label p">
                                            {account.authorization_received ? renderYN(account.authorization_received) : "None"}
                                        </span>
                                    </div>
                                    <div className="col-xl-3">
                                        <label className="col-lg-12 col-form-label">
                                            {t('One Time Use Only')}
                                            <Tooltip content={t("One Time Use Only Tooltip")}></Tooltip>
                                        </label>
                                    </div>
                                    <div className="col-xl-3">
                                        <span className="col-lg-8 view-label p">
                                            {account.one_time_use_only ? renderYN(account.one_time_use_only) : "None"}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-3">
                                        <label className="col-lg-12 col-form-label">
                                            {t('Status')}
                                            <Tooltip content={t("Status Tooltip")}></Tooltip>
                                        </label>
                                    </div>
                                    <div className="col-xl-3">
                                        <span className="col-lg-8 view-label p">
                                            {account.active_yn ? renderStatus(account.active_yn) : "None"}
                                        </span>
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-xl-3">
                                        <button type="button" className="btn btn-secondary" onClick={()=>handleshowHide()}>
                                            {t("Back")}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
        :
        <AchIndex id={id}
            setHideShowAchIndex={setHideShowAchIndex}
            setHideShowAchEdit={setHideShowAchEdit}
            hideShowachindex={hideShowachindex}
            hideShowachedit={hideShowachedit}
            setHideShowAchID={setHideShowAchID}/>
    );
}

export default ViewAchAccount;